// src/pages/LoginPage.jsx
// Standalone /login page — same two-step Supabase email-OTP flow as the modal.
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import OtpForm from "../auth/OtpForm";
import "../auth/LoginPage.css";

function LoginPage() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <div className="login-card">
        {loading ? (
          <div className="login-loading">Loading…</div>
        ) : user ? (
          <>
            <h2 className="login-title">You're signed in</h2>
            <p className="login-signedin">
              Signed in as <strong>{user.email}</strong>
            </p>
            <div className="login-actions">
              <button
                type="button"
                className="login-secondary"
                onClick={() => signOut()}
              >
                Sign out
              </button>
              <Link className="login-home-link" to="/">
                Back to home
              </Link>
            </div>
          </>
        ) : (
          <>
            <h2 className="login-title">Sign in</h2>
            <OtpForm onSuccess={() => navigate("/")} />
          </>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
